import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { usePersona } from '@/auth/usePersona';
import { ROUTES } from './routeConstants';
import { telemetry } from '@services/telemetry';
import { TELEMETRY_COMPONENT, EVENT_TYPES } from '@/constants';

export const DefaultRedirect = () => {
  const { isAdmin } = usePersona();
  const location = useLocation();

  const targetPath = isAdmin ? ROUTES.ADMIN : ROUTES.BOOKINGS;

  React.useEffect(() => {
    if (location.pathname !== targetPath) {
      telemetry.trackEvent(TELEMETRY_COMPONENT, EVENT_TYPES.NAVIGATION, {
        action: 'redirect',
        from: location.pathname,
        to: targetPath,
      });
    }
  }, [location.pathname, targetPath]);

  return location.pathname !== targetPath ? <Navigate to={targetPath} replace /> : null;
};

DefaultRedirect.displayName = 'DefaultRedirect';
